import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["announcementId", "enabled", "includeUnformattedMessage"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import isAdmin from 'utils/session/isAdmin';
import { announcementQueryKeys } from 'actions/announcements';
export var ANNOUNCEMENTS_PER_PAGE = 10;
export var useFetchAnnouncement = function useFetchAnnouncement(_ref) {
  var announcementId = _ref.announcementId,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$includeUnformatt = _ref.includeUnformattedMessage,
    includeUnformattedMessage = _ref$includeUnformatt === void 0 ? false : _ref$includeUnformatt,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchAnnouncement() {
    return _fetchAnnouncement.apply(this, arguments);
  }
  function _fetchAnnouncement() {
    _fetchAnnouncement = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return api('get', '/api/query/announcement', {
              fields: ['id', 'title', 'callOut', 'HTMLmessage', includeUnformattedMessage ? 'message' : undefined, 'videoUrl', 'buttonLabel', 'buttonLink', 'publishTime'],
              filter: {
                id: announcementId
              }
            });
          case 1:
            res = _context.sent;
            return _context.abrupt("return", res === null || res === void 0 ? void 0 : res.items[0]);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchAnnouncement.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: announcementQueryKeys.singleAnnouncement(announcementId, {
        includeUnformattedMessage: includeUnformattedMessage
      }),
      queryFn: fetchAnnouncement
    }, queryOptions), {}, {
      enabled: enabled && isAdmin()
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
};
export default useFetchAnnouncement;